import i18n from 'services/base/i18n';

export default {
  // Label for the save button
  save: () => i18n.pgettext('Pages|Edit Device', 'SAVE'),
  // Label for the device name input box
  deviceNameLabel: () => i18n.pgettext('Pages|Edit Device', 'DEVICE NAME'),
  deviceNameValue: (value: string) => value,
  // Label for the device type input box
  deviceTypeLabel: () => i18n.pgettext('Pages|Edit Device', 'DEVICE TYPE'),
  deviceTypeValue: (value: string) => value,
  // Label for the operating system input box
  operatingSystemLabel: () => i18n.pgettext('Pages|Edit Device', 'OPERATING SYSTEM'),
  operatingSystemValue: (value: string) => value,
};
